var _path, _mask, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoinHead = function SvgCoinHead(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 160 160"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#coin-head_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coin-head_svg__b)",
    d: "M79.991 0c44.185 0 80 35.82 80 80s-35.815 80-80 80-80-35.82-80-80 35.815-80 80-80"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#coin-head_svg__c)",
    fillOpacity: 0.32,
    d: "M79.991 0c44.185 0 80 35.82 80 80s-35.815 80-80 80-80-35.82-80-80 35.815-80 80-80",
    style: {
      mixBlendMode: "plus-lighter"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#coin-head_svg__d)",
    fillOpacity: 0.16,
    d: "M79.991 0c44.185 0 80 35.82 80 80s-35.815 80-80 80-80-35.82-80-80 35.815-80 80-80",
    style: {
      mixBlendMode: "plus-darker"
    }
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BA94FB",
    strokeOpacity: 0.12,
    strokeWidth: 5.161,
    d: "M79.991 2.58c42.76 0 77.42 34.665 77.42 77.42s-34.66 77.419-77.42 77.419S2.571 122.755 2.571 80s34.66-77.42 77.42-77.42Z",
    style: {
      mixBlendMode: "screen"
    }
  }), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "coin-head_svg__v",
    width: 65,
    height: 65,
    x: 49.25,
    y: 48.351,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M49.25 48.351h65v65h-65z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M51.33 74.13c-.097.823-.158 2.513.136 2.766.379.327 13.096-5.9 31.796-5.245s26.625 5.115 26.867 5.245c.239.132-.901-5.475-1.763-6.623s-9.26-7.623-21.45-8.21c-13.335-.649-24.968 1.007-34.874 10.839-.355.352-.65.71-.712 1.228",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M52.079 68.536c.102-4.897 2.695-10.136 6.452-12.927 0 0-2.301 6.59 1.477 2.906 1.668-1.626 8.566-7.348 12.859-8.103 1.327-.236.41.227-.247 1.125-.644.88-1.022 2.201-.155 1.72 3.418-1.89 9.056-1.852 12.368-1.65 2.057.125 1.936.323.34.683-2.242.503-4.123 1.48-3.81 1.398 3.457-.91 15.045 1.01 15.88 2.718.234.48-3.688 1.564-3.162 1.576 5.264.105 10.369 1.88 12.681 6.175.654 1.216 1.234 4.264 1.234 4.264-11.64-11.372-41.121-11.714-54.438.94-1.56 1.484-1.534 1.829-1.479-.825M63.044 75.425c1.923-.506 4.29-1.036 5.75-1.036 2.79 0 3.892 1.213 4.96 1.115 1.067-.097 3.616-1.705 4.58-1.705s.483.69 1.206.69c.722 0 3.58-.885 4.923-1.018.835-.08-.938 1.13-2.401 2.059-2.241 1.423-3.434 1.025-6.216 1.03l-11.517.035c-4.797.01-5.914.047-1.285-1.17M84.989 75.576s2.212-1.235 3.176-1.563 1.689 0 3.376.228c1.686.23 1.67.095 4.802.455 3.134.36 7.025 1.966 4.321 1.966-2.703 0-8.658-.125-14.065-.125-1.195 0-3.625-.138-1.61-.96",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M104.995 76.772c1.004.365 2.273.733 3.276 1.098 1.658.605 1.348.285 1.353 2.008.016 4.947.029 9.219-1.644 14.356-7.648 23.462-52.347 24.362-55.547-8.781-.257-2.676-.41-3.962-.496-4.982-.166-1.916.543-2.208 2.374-2.706l2.696-.643c1.19-.285.967.918.953 2.426-.026 3.136-.223 9.231-.223 9.411 0 .23-1.07-3.08-1.07-3.08-.204 15.43 9.837 22.998 25.554 23.178 6.274.071 13.406-3.346 17.941-8.335 5.067-5.58 4.432-8.896 4.786-15.6l-1.274 4.198c-.068-3.582-.137-7.794-.207-11.378-.037-2.015-.397-1.875 1.528-1.17",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M63.373 78.263s7.989 5.705 18.321 5.244c10.33-.46 15.91-5.244 15.91-5.244zM65.837 81.764s-4.579.46-3.615 5.05c.78 3.721 4.343 4.972 7.374 4.256 5.16-1.218 5.391-4.879 4.782-5.174zM96.007 81.764s4.579.46 3.614 5.05c-.78 3.721-4.342 4.972-7.374 4.256-5.16-1.218-5.39-4.879-4.781-5.174zM60.506 91.821s5.025 2.557 8.78 2.426c3.753-.132 7.42-1.7 12.139-1.733 4.716-.032 6.801 1.7 10.658 1.7s8.919-2.032 8.919-2.032c-2.007 3.481-7.17 4.364-11.675 3.541 0 0 5.546 1.703 8.54 1.145 2.998-.555 3.377-1.277 3.377-1.277s-5.168 12.457-20.008 12.194c-6.741-.117-11.339-2.023-14.368-4.109-3.452-2.376-4.805-4.369-6.123-7.953 2.585 1.946 8.088 1.886 10.847.458-4.083 1.193-10.099-.118-11.086-4.36M68.068 54.916c-2.359 1.503-5.17 3.29-8.44 6.125-2.16 1.873-2.601 1.905-.581-.636.959-1.205 2.194-2.353 3.554-3.359 1.608-1.185 3.395-2.17 5.118-2.808 2.511-.93 2.275-.545.35.678M63.822 67.446c1.939-1.588 4.508-2.676 7.175-3.229 2.808-.582 5.732-.572 8.149.06.14.035.22.173.181.303a.25.25 0 0 1-.205.178c-.475.08-1.098.182-1.78.29-4.215.675-10.77 1.723-13.601 3.201a.267.267 0 0 1-.352-.1.24.24 0 0 1 .034-.283l.362-.385a.2.2 0 0 1 .037-.035",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M72.737 81.212c1.8.84 4.046 1.343 5.761 1.43 1.27.065 2.246.055 2.585-.212 1.235-.988-8.254-1.27-8.346-1.218M108.007 88.412c.693-2.096.985-4.645.898-6.553-.063-1.416-.173-2.496-.489-2.836-1.158-1.25-.475 9.291-.409 9.389M58.22 103.277c-.684-.748-5.58-6.493-6.852-8.486.864 3.761 3.796 7.575 6.6 9.296 2.127 1.308 1 .01.251-.81M102.968 104.979c1.303-1.436 2.514-2.722 3.583-4.322l1.881.025zM108 97.957c.743-1.073 1.216-2.296 1.216-2.296s1.638-1.042 2.857-4.785c0 2.794-3.067 6.763-4.073 7.081M81.686 58.567c-2.43.172-5.325.38-9.027 1.185-2.443.533-2.787.38-.15-.708 1.25-.515 2.683-.877 4.146-1.083 1.726-.24 3.5-.26 5.07-.045 2.288.316 1.942.508-.04.65",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coin-head_svg__e)",
    fillRule: "evenodd",
    d: "M51.33 74.13c-.097.823-.158 2.513.136 2.766.379.327 13.096-5.9 31.796-5.245s26.625 5.115 26.867 5.245c.239.132-.901-5.475-1.763-6.623s-9.26-7.623-21.45-8.21c-13.335-.649-24.968 1.007-34.874 10.839-.355.352-.65.71-.712 1.228",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coin-head_svg__f)",
    fillRule: "evenodd",
    d: "M52.079 68.536c.102-4.897 2.695-10.136 6.452-12.927 0 0-2.301 6.59 1.477 2.906 1.668-1.626 8.566-7.348 12.859-8.103 1.327-.236.41.227-.247 1.125-.644.88-1.022 2.201-.155 1.72 3.418-1.89 9.056-1.852 12.368-1.65 2.057.125 1.936.323.34.683-2.242.503-4.123 1.48-3.81 1.398 3.457-.91 15.045 1.01 15.88 2.718.234.48-3.688 1.564-3.162 1.576 5.264.105 10.369 1.88 12.681 6.175.654 1.216 1.234 4.264 1.234 4.264-11.64-11.372-41.121-11.714-54.438.94-1.56 1.484-1.534 1.829-1.479-.825",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coin-head_svg__g)",
    fillRule: "evenodd",
    d: "M63.044 75.425c1.923-.506 4.29-1.036 5.75-1.036 2.79 0 3.892 1.213 4.96 1.115 1.067-.097 3.616-1.705 4.58-1.705s.483.69 1.206.69c.722 0 3.58-.885 4.923-1.018.835-.08-.938 1.13-2.401 2.059-2.241 1.423-3.434 1.025-6.216 1.03l-11.517.035c-4.797.01-5.914.047-1.285-1.17",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coin-head_svg__h)",
    fillRule: "evenodd",
    d: "M84.989 75.576s2.212-1.235 3.176-1.563 1.689 0 3.376.228c1.686.23 1.67.095 4.802.455 3.134.36 7.025 1.966 4.321 1.966-2.703 0-8.658-.125-14.065-.125-1.195 0-3.625-.138-1.61-.96",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coin-head_svg__i)",
    fillRule: "evenodd",
    d: "M104.995 76.772c1.004.365 2.273.733 3.276 1.098 1.658.605 1.348.285 1.353 2.008.016 4.947.029 9.219-1.644 14.356-7.648 23.462-52.347 24.362-55.547-8.781-.257-2.676-.41-3.962-.496-4.982-.166-1.916.543-2.208 2.374-2.706l2.696-.643c1.19-.285.967.918.953 2.426-.026 3.136-.223 9.231-.223 9.411 0 .23-1.07-3.08-1.07-3.08-.204 15.43 9.837 22.998 25.554 23.178 6.274.071 13.406-3.346 17.941-8.335 5.067-5.58 4.432-8.896 4.786-15.6l-1.274 4.198c-.068-3.582-.137-7.794-.207-11.378-.037-2.015-.397-1.875 1.528-1.17",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coin-head_svg__j)",
    fillRule: "evenodd",
    d: "M63.373 78.263s7.989 5.705 18.321 5.244c10.33-.46 15.91-5.244 15.91-5.244z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coin-head_svg__k)",
    fillRule: "evenodd",
    d: "M65.837 81.764s-4.579.46-3.615 5.05c.78 3.721 4.343 4.972 7.374 4.256 5.16-1.218 5.391-4.879 4.782-5.174z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coin-head_svg__l)",
    fillRule: "evenodd",
    d: "M96.007 81.764s4.579.46 3.614 5.05c-.78 3.721-4.342 4.972-7.374 4.256-5.16-1.218-5.39-4.879-4.781-5.174z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coin-head_svg__m)",
    fillRule: "evenodd",
    d: "M60.506 91.821s5.025 2.557 8.78 2.426c3.753-.132 7.42-1.7 12.139-1.733 4.716-.032 6.801 1.7 10.658 1.7s8.919-2.032 8.919-2.032c-2.007 3.481-7.17 4.364-11.675 3.541 0 0 5.546 1.703 8.54 1.145 2.998-.555 3.377-1.277 3.377-1.277s-5.168 12.457-20.008 12.194c-6.741-.117-11.339-2.023-14.368-4.109-3.452-2.376-4.805-4.369-6.123-7.953 2.585 1.946 8.088 1.886 10.847.458-4.083 1.193-10.099-.118-11.086-4.36",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coin-head_svg__n)",
    fillRule: "evenodd",
    d: "M68.068 54.916c-2.359 1.503-5.17 3.29-8.44 6.125-2.16 1.873-2.601 1.905-.581-.636.959-1.205 2.194-2.353 3.554-3.359 1.608-1.185 3.395-2.17 5.118-2.808 2.511-.93 2.275-.545.35.678",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coin-head_svg__o)",
    fillRule: "evenodd",
    d: "M63.822 67.446c1.939-1.588 4.508-2.676 7.175-3.229 2.808-.582 5.732-.572 8.149.06.14.035.22.173.181.303a.25.25 0 0 1-.205.178c-.475.08-1.098.182-1.78.29-4.215.675-10.77 1.723-13.601 3.201a.267.267 0 0 1-.352-.1.24.24 0 0 1 .034-.283l.362-.385a.2.2 0 0 1 .037-.035",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coin-head_svg__p)",
    fillRule: "evenodd",
    d: "M72.737 81.212c1.8.84 4.046 1.343 5.761 1.43 1.27.065 2.246.055 2.585-.212 1.235-.988-8.254-1.27-8.346-1.218",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coin-head_svg__q)",
    fillRule: "evenodd",
    d: "M108.007 88.412c.693-2.096.985-4.645.898-6.553-.063-1.416-.173-2.496-.489-2.836-1.158-1.25-.475 9.291-.409 9.389",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coin-head_svg__r)",
    fillRule: "evenodd",
    d: "M58.22 103.277c-.684-.748-5.58-6.493-6.852-8.486.864 3.761 3.796 7.575 6.6 9.296 2.127 1.308 1 .01.251-.81",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coin-head_svg__s)",
    fillRule: "evenodd",
    d: "M102.968 104.979c1.303-1.436 2.514-2.722 3.583-4.322l1.881.025z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coin-head_svg__t)",
    fillRule: "evenodd",
    d: "M108 97.957c.743-1.073 1.216-2.296 1.216-2.296s1.638-1.042 2.857-4.785c0 2.794-3.067 6.763-4.073 7.081",
    clipRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#coin-head_svg__u)",
    fillRule: "evenodd",
    d: "M81.686 58.567c-2.43.172-5.325.38-9.027 1.185-2.443.533-2.787.38-.15-.708 1.25-.515 2.683-.877 4.146-1.083 1.726-.24 3.5-.26 5.07-.045 2.288.316 1.942.508-.04.65",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#CAA5FF",
    strokeOpacity: 0.44,
    strokeWidth: 2.581,
    d: "M51.33 74.13c-.097.823-.158 2.513.136 2.766.379.327 13.096-5.9 31.796-5.245s26.625 5.115 26.867 5.245c.239.132-.901-5.475-1.763-6.623s-9.26-7.623-21.45-8.21c-13.335-.649-24.968 1.007-34.874 10.839-.355.352-.65.71-.712 1.228Z",
    clipRule: "evenodd",
    mask: "url(#coin-head_svg__v)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#CAA5FF",
    strokeOpacity: 0.44,
    strokeWidth: 2.581,
    d: "M52.079 68.536c.102-4.897 2.695-10.136 6.452-12.927 0 0-2.301 6.59 1.477 2.906 1.668-1.626 8.566-7.348 12.859-8.103 1.327-.236.41.227-.247 1.125-.644.88-1.022 2.201-.155 1.72 3.418-1.89 9.056-1.852 12.368-1.65 2.057.125 1.936.323.34.683-2.242.503-4.123 1.48-3.81 1.398 3.457-.91 15.045 1.01 15.88 2.718.234.48-3.688 1.564-3.162 1.576 5.264.105 10.369 1.88 12.681 6.175.654 1.216 1.234 4.264 1.234 4.264-11.64-11.372-41.121-11.714-54.438.94-1.56 1.484-1.534 1.829-1.479-.825ZM63.044 75.425c1.923-.506 4.29-1.036 5.75-1.036 2.79 0 3.892 1.213 4.96 1.115 1.067-.097 3.616-1.705 4.58-1.705s.483.69 1.206.69c.722 0 3.58-.885 4.923-1.018.835-.08-.938 1.13-2.401 2.059-2.241 1.423-3.434 1.025-6.216 1.03l-11.517.035c-4.797.01-5.914.047-1.285-1.17ZM84.989 75.576s2.212-1.235 3.176-1.563 1.689 0 3.376.228c1.686.23 1.67.095 4.802.455 3.134.36 7.025 1.966 4.321 1.966-2.703 0-8.658-.125-14.065-.125-1.195 0-3.625-.138-1.61-.96Z",
    clipRule: "evenodd",
    mask: "url(#coin-head_svg__v)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#CAA5FF",
    strokeOpacity: 0.44,
    strokeWidth: 2.581,
    d: "M104.995 76.772c1.004.365 2.273.733 3.276 1.098 1.658.605 1.348.285 1.353 2.008.016 4.947.029 9.219-1.644 14.356-7.648 23.462-52.347 24.362-55.547-8.781-.257-2.676-.41-3.962-.496-4.982-.166-1.916.543-2.208 2.374-2.706l2.696-.643c1.19-.285.967.918.953 2.426-.026 3.136-.223 9.231-.223 9.411 0 .23-1.07-3.08-1.07-3.08-.204 15.43 9.837 22.998 25.554 23.178 6.274.071 13.406-3.346 17.941-8.335 5.067-5.58 4.432-8.896 4.786-15.6l-1.274 4.198c-.068-3.582-.137-7.794-.207-11.378-.037-2.015-.397-1.875 1.528-1.17Z",
    clipRule: "evenodd",
    mask: "url(#coin-head_svg__v)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#CAA5FF",
    strokeOpacity: 0.44,
    strokeWidth: 2.581,
    d: "M63.373 78.263s7.989 5.705 18.321 5.244c10.33-.46 15.91-5.244 15.91-5.244zM65.837 81.764s-4.579.46-3.615 5.05c.78 3.721 4.343 4.972 7.374 4.256 5.16-1.218 5.391-4.879 4.782-5.174zM96.007 81.764s4.579.46 3.614 5.05c-.78 3.721-4.342 4.972-7.374 4.256-5.16-1.218-5.39-4.879-4.781-5.174zM60.506 91.821s5.025 2.557 8.78 2.426c3.753-.132 7.42-1.7 12.139-1.733 4.716-.032 6.801 1.7 10.658 1.7s8.919-2.032 8.919-2.032c-2.007 3.481-7.17 4.364-11.675 3.541 0 0 5.546 1.703 8.54 1.145 2.998-.555 3.377-1.277 3.377-1.277s-5.168 12.457-20.008 12.194c-6.741-.117-11.339-2.023-14.368-4.109-3.452-2.376-4.805-4.369-6.123-7.953 2.585 1.946 8.088 1.886 10.847.458-4.083 1.193-10.099-.118-11.086-4.36ZM68.068 54.916c-2.359 1.503-5.17 3.29-8.44 6.125-2.16 1.873-2.601 1.905-.581-.636.959-1.205 2.194-2.353 3.554-3.359 1.608-1.185 3.395-2.17 5.118-2.808 2.511-.93 2.275-.545.35.678ZM63.822 67.446c1.939-1.588 4.508-2.676 7.175-3.229 2.808-.582 5.732-.572 8.149.06.14.035.22.173.181.303a.25.25 0 0 1-.205.178c-.475.08-1.098.182-1.78.29-4.215.675-10.77 1.723-13.601 3.201a.267.267 0 0 1-.352-.1.24.24 0 0 1 .034-.283l.362-.385a.2.2 0 0 1 .037-.035Z",
    clipRule: "evenodd",
    mask: "url(#coin-head_svg__v)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#CAA5FF",
    strokeOpacity: 0.44,
    strokeWidth: 2.581,
    d: "M72.737 81.212c1.8.84 4.046 1.343 5.761 1.43 1.27.065 2.246.055 2.585-.212 1.235-.988-8.254-1.27-8.346-1.218ZM108.007 88.412c.693-2.096.985-4.645.898-6.553-.063-1.416-.173-2.496-.489-2.836-1.158-1.25-.475 9.291-.409 9.389ZM58.22 103.277c-.684-.748-5.58-6.493-6.852-8.486.864 3.761 3.796 7.575 6.6 9.296 2.127 1.308 1 .01.251-.81ZM102.968 104.979c1.303-1.436 2.514-2.722 3.583-4.322l1.881.025zM108 97.957c.743-1.073 1.216-2.296 1.216-2.296s1.638-1.042 2.857-4.785c0 2.794-3.067 6.763-4.073 7.081ZM81.686 58.567c-2.43.172-5.325.38-9.027 1.185-2.443.533-2.787.38-.15-.708 1.25-.515 2.683-.877 4.146-1.083 1.726-.24 3.5-.26 5.07-.045 2.288.316 1.942.508-.04.65Z",
    clipRule: "evenodd",
    mask: "url(#coin-head_svg__v)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#coin-head_svg__w)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.08,
    d: "M79.5 13C42.219 13 12 43.22 12 80.5S42.22 148 79.5 148 147 117.78 147 80.5 116.781 13 79.5 13m0 124.616c-31.543 0-57.115-25.572-57.115-57.116 0-31.543 25.572-57.115 57.115-57.115s57.116 25.571 57.116 57.115-25.567 57.116-57.116 57.116",
    style: {
      mixBlendMode: "plus-darker"
    }
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "coin-head_svg__b",
    x1: 74.005,
    x2: -53.264,
    y1: 200,
    y2: 148.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E83FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D52EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coin-head_svg__c",
    x1: 79.991,
    x2: 37.41,
    y1: 80,
    y2: 11.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coin-head_svg__d",
    x1: 79.991,
    x2: 123.862,
    y1: 69.677,
    y2: 152.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coin-head_svg__e",
    x1: 67.253,
    x2: 96.694,
    y1: 46.473,
    y2: 112.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#F9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#E7DFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coin-head_svg__f",
    x1: 67.253,
    x2: 96.694,
    y1: 46.473,
    y2: 112.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#F9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#E7DFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coin-head_svg__g",
    x1: 67.253,
    x2: 96.694,
    y1: 46.473,
    y2: 112.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#F9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#E7DFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coin-head_svg__h",
    x1: 67.253,
    x2: 96.694,
    y1: 46.473,
    y2: 112.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#F9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#E7DFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coin-head_svg__i",
    x1: 67.253,
    x2: 96.694,
    y1: 46.473,
    y2: 112.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#F9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#E7DFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coin-head_svg__j",
    x1: 67.253,
    x2: 96.694,
    y1: 46.473,
    y2: 112.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#F9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#E7DFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coin-head_svg__k",
    x1: 67.253,
    x2: 96.694,
    y1: 46.473,
    y2: 112.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#F9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#E7DFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coin-head_svg__l",
    x1: 67.253,
    x2: 96.694,
    y1: 46.473,
    y2: 112.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#F9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#E7DFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coin-head_svg__m",
    x1: 67.253,
    x2: 96.694,
    y1: 46.473,
    y2: 112.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#F9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#E7DFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coin-head_svg__n",
    x1: 67.253,
    x2: 96.694,
    y1: 46.473,
    y2: 112.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#F9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#E7DFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coin-head_svg__o",
    x1: 67.253,
    x2: 96.694,
    y1: 46.473,
    y2: 112.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#F9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#E7DFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coin-head_svg__p",
    x1: 67.253,
    x2: 96.694,
    y1: 46.473,
    y2: 112.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#F9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#E7DFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coin-head_svg__q",
    x1: 67.253,
    x2: 96.694,
    y1: 46.473,
    y2: 112.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#F9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#E7DFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coin-head_svg__r",
    x1: 67.253,
    x2: 96.694,
    y1: 46.473,
    y2: 112.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#F9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#E7DFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coin-head_svg__s",
    x1: 67.253,
    x2: 96.694,
    y1: 46.473,
    y2: 112.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#F9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#E7DFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coin-head_svg__t",
    x1: 67.253,
    x2: 96.694,
    y1: 46.473,
    y2: 112.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#F9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#E7DFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "coin-head_svg__u",
    x1: 67.253,
    x2: 96.694,
    y1: 46.473,
    y2: 112.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487,
    stopColor: "#F9F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#E7DFFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "coin-head_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-.003 0h160v160h-160z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "coin-head_svg__w",
    width: 135,
    height: 142.742,
    x: 12,
    y: 13,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.742
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.032
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.217373 0 0 0 0 0.0967634 0 0 0 0 0.498796 0 0 0 0.53 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_20321_2975"
  })))));
};
export default SvgCoinHead;